import { useState } from 'react';
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

const defaultState = null;

interface UploadFileDialogProps {
  open: boolean;
  onSuccessHandler: (file: File) => void;
  onClose: () => void;
}

export const UploadFileDialog = ({
  open,
  onSuccessHandler,
  onClose,
}: UploadFileDialogProps) => {
  const [file, setFile] = useState<any>(defaultState);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files ? event.target.files[0] : null;
    if (selectedFile) {
      // Check if the file is a valid CSV or Excel file
      const validFileTypes = ['text/csv', 'application/vnd.ms-excel'];
      if (!validFileTypes.includes(selectedFile.type)) {
        setFile(defaultState);

        throw new Error('Invalid file type. Please upload a CSV or Excel file.');
      }
      setFile(selectedFile);
    } else {
      setFile(defaultState);
    }
  };

  const onSuccess = () => {
    setFile(defaultState);
    onSuccessHandler(file);
  };

  const onCancel = () => {
    setFile(defaultState);
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {}}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Upload Participants</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '400px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Button variant='contained' component='label'>
              Upload File
              <input
                hidden
                multiple
                type='file'
                onChange={handleFileChange}
              />
            </Button>
            <span>{file && file.name}</span>
          </Box>
          <Box sx={{ width: '100%' }}></Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button onClick={() => onSuccess()} autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
